import { useCallback, useEffect, useRef, useState } from "react";

const AsyncHelper = {
	useIntervalAsync(
		fn: () => Promise<unknown>,
		ms: number,
		conditionallyStop = false
	) {
		const [dead, kill] = useState(false);
		const timeout = useRef<number>();
		const mountedRef = useRef(false);

		const run = useCallback(async () => {
			const responseShouldStop = await fn();
			if (responseShouldStop && conditionallyStop) {
				return;
			}
			if (mountedRef.current) {
				timeout.current = window.setTimeout(run, ms);
			}
		}, [fn, ms]);

		useEffect(() => {
			if (dead) {
				return () => {};
			}
			mountedRef.current = true;
			run();
			return () => {
				mountedRef.current = false;
				window.clearTimeout(timeout.current);
			};
		}, [run, dead]);

		return [() => kill(true), () => kill(false)];
	}
};

export default AsyncHelper;
